<template>
  <header class="page-title-bar mb-2 px-0">
    <div class="row text-center text-sm-left">
      <div class="col">
        <h1 class="page-title text-left">{{ protocol.title }}</h1>
        <span v-if="protocol.is_secondary"
              class="badge badge-info">Protocolo secundario</span>
        
        <div class="d-flex mt-3 mb-3">
          <a class="btn-account" href="#">
            <div class="user-avatar mr-2">
              <img alt="" :src="protocol.user.avatar"/>
            </div>
            <div class="account-summary">
              <h1 class="card-title">{{ protocol.user.full_name }}</h1>
              <h6 class="card-subtitle text-muted">Responsable de protocolo</h6>
            </div>
          </a>
        </div>
        
        <hr/>
        
        <span class="font-weight-bold d-block text-left">Resumen del protocolo:</span>
        
        <p class="protocol-summary w-100 text-left m-0">
          <span v-if="!readMore">{{ protocol.summary.slice(0, 200) }}</span>
          <span v-if="readMore">{{ protocol.summary }}</span>
          <a
            href="#"
            @click="toggleReadMore"
            v-if="protocol.summary.length > 200"
          >
            <span v-if="!readMore">Leer más...</span>
            <span v-if="readMore">Mostrar menos</span></a
          >
        </p>
      </div>
    </div>
    
    <div class="row mb-3 mt-3">
      <div class="col">
        <div class="d-md-flex">
          <!-- TODO: Change URL when ids are obfuscated -->
          <a
            :href="`/protocolo/${protocol.id}/editar`"
            v-if="canEdit"
            class="btn btn-outline-primary d-md-block mt-3 mt-md-0 mr-md-0">Editar datos generales del protocolo</a>
          <button
            v-if="canDelete"
            class="btn btn-outline-danger d-md-block mt-3 mt-md-0 mr-md-0 ml-md-2"
            data-toggle="modal"
            data-target="#delete-protocol-modal">Eliminar protocolo
          </button>
        </div>
      </div>
    </div>
    
    <div class="row mb-3">
      <div class="col">
        <div class="d-inline-block mr-2">
          <span>Centro:</span>
          <strong>{{
              protocol.workplace
                ? protocol.workplace.key.toUpperCase()
                : 'No asignado'
                  }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Código:</span>
          <strong>{{ protocol.id }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>CI:</span>
          <strong>{{ protocol.ci ? protocol.ci : 'No asignado' }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Fecha de creación:</span>
          <strong>{{ formatDate(protocol.created_at, 'DD/MM/YYYY') }}</strong>
        </div>
        
        <div class="d-inline-block mr-2">
          <span>Tipo de estudio:</span>
          <strong>{{
              protocol.study_type ? protocol.study_type.title : 'No asignado'
                  }}</strong>
        </div>
      </div>
    </div>
    
    <div class="row mb-3">
      <div class="col">
        <span>Estatus del protocolo:</span>
        <strong>{{ protocol.status ? protocol.status.title : '' }}</strong>
      </div>
    </div>
    
    <ok-cancel-dialog title="Eliminar protocolo"
                      id="delete-protocol-modal"
                      ref="delete-protocol-modal"
                      content="<p>¿Esta seguro eliminar el protocolo?</p>"
                      ok-button-text="Confirmar"
                      :ok-callback="removeProtocol"></ok-cancel-dialog>
  </header>
</template>

<script>
  import moment from 'moment'
  import OkCancelDialog from '../../ui/OkCancelDialog'
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../../utils/AlertManager'
  
  export default {
    name: 'ProtocolHeader',
    components: {
      OkCancelDialog,
    },
    props: {
      protocol: Object,
      task: {
        type: Object,
        required: false,
        default: null,
      },
      showDetails: {
        type: Boolean,
        default: false,
      },
      conditioned: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        readMore: false,
        saving: false,
      }
    },
    methods: {
      ...mapActions({
        deleteProtocol: 'protocols/deleteProtocol',
      }),
      toggleReadMore () {
        this.readMore = !this.readMore
      },
      formatDate (date, format) {
        return moment(date).format(format)
      },
      async removeProtocol () {
        const response = await this.deleteProtocol({
          protocol: this.protocol,
        })
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        setTimeout(() => {
          location.href = '/'
        }, 1000)
      },
    },
    computed: {
      ...mapGetters(['user']),
      
      ciAssigmentDate () {
        if (this.protocol) {
          return moment(this.protocol.ci_assignment_date).format('DD/MM/YYYY')
        }
        
        return ''
      },
      canEdit () {
        return (
          (this.protocol.user_id === this.user.id || user.roles
              .map((role) => role.key)
              .some((role) =>
                [
                  'root',
                  'administrador',
                  'coordinador',
                  'secretario_investigacion',
                  'presidente_investigacion',
                ].includes(role),
              )) && ((
            this.protocol.status.key === 'reg' ||
            this.protocol.status.key === 'envio_evaluacion_comites' ||
            this.protocol.status.key === 'envio_evaluacion_lider_linea' ||
            this.protocol.status.key === 'envio_evaluacion_dir_centro' ||
            this.protocol.status.key === 'desarrollo' ||
            this.protocol.status.key === 'solicitud_desarrollo') && !this.readonly) || this.conditioned
        )
      },
      canDelete () {
        const userHasRole = user.roles
          .map((role) => role.key)
          .some((role) =>
            [
              'root',
              'administrador',
            ].includes(role),
          )
        
        return (
          this.protocol.status.key === 'reg' &&
          (this.protocol.user_id === this.user.id || userHasRole)
        )
      },
    },
    mounted () {
      window.conditioned = this.conditioned
    }
  }
</script>
